import { Group, Paper, Text } from "@mantine/core"
import classes from "./hint.module.css"
import { useTranslation } from "react-i18next"

export function Hint({ hint }: { hint: string }) {
  const { t } = useTranslation("app_server")
  return (
    <Paper withBorder radius="md" className={classes.card}>
      <Group align="center">
        <Text size="xl" fw={500}>
          {t("Hint")}
        </Text>
      </Group>
      <Text mt="md">{hint}</Text>
    </Paper>
  )
}
